// /utils/common.js

export const categories = [
  { id: 1, title: 'Construction' },
  { id: 2, title: 'Eduction' },
  { id: 3, title: 'Healthcare' },
  { id: 4, title: 'Science' },
  { id: 5, title: 'Technology' },
  { id: 6, title: 'Transportation' },
  // Add more categories as needed
];


export const getMimeType = (filename) => {
  const extension = filename.split('.').pop().toLowerCase();
  const mimeTypes = {
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    mpeg: 'video/mpeg',
    mpg: 'video/mpeg',
    mkv: 'video/x-matroska',
    webm: 'video/webm',
  };
  return mimeTypes[extension] || 'video/mp4'; // default fallback
};

/**
 * Takes a semicolon-separated list of category IDs (e.g. "1;3;4")
 * and returns JSX displaying their titles
 */
export function explodeCategories(categoryIds) {
  if (!categoryIds || typeof categoryIds !== 'string') return null;

  const categoryIdArray = categoryIds.split(';').map(Number);
  const selectedCategories = categories.filter((category) =>
    categoryIdArray.includes(category.id)
  );

  return (
    <div>
      {selectedCategories.map((category) => (
        <div className="font-small txt-777 pb-5" key={category.id}>
          {category.title}
        </div>
      ))}
    </div>
  );
}

/**
 * Converts a datetime string into MM/DD/YY format
 */
export function convertDateTimeToText(some_date_time) {
  if (!some_date_time || some_date_time === '') return '';

  const date = new Date(some_date_time);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return `${month}/${day}/${year}`;
}

/**
 * Converts a datetime string into Aug 04, 2024
 */
export function formatPublishedDate(dateString) {

    if (!dateString)
        return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
    });

}
/**
 * Converts a cents integer into dollars 2-digit float
 */
export function convertCentsToDollars(some_cents) {
  if (typeof some_cents !== "number" || isNaN(some_cents)) {
    throw new Error("Input must be a valid number");
  }
  return (some_cents / 100).toFixed(2);
}
/*
function explodeCategories2(categoryIds){
	  const categoryIdArray = categoryIds.split(';').map(Number); // Convert string IDs to numbers
  const selectedCategories = categories.filter(category => categoryIdArray.includes(category.id));

  return (
    <span><u>Categories:</u>&nbsp;
      {selectedCategories.map((category, index) => (
        <span className="txt-777">{category.title}{index + 1 === selectedCategories.length ? '' : ', '}</span>
      ))}
    </span>
  );
}
*/
export function shortenSomeString(some_string) {
	return some_string.slice(0, some_string.length / 2) + '...';
}